import { cn } from "@/lib/utils";

export default function MatchRing({ score = 0, size = 52, label = "match" }) {
    const strokeWidth = Math.max(3, size * 0.08);
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (score / 100) * circumference;

    const tone = score >= 85 ? "text-success" : score >= 70 ? "text-accent" : "text-muted-foreground";

    return (
        <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} aria-label={`${score}% ${label}`}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="hsl(var(--secondary))" strokeWidth={strokeWidth} fill="none" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="currentColor"
                    className={cn(tone, "transition-[stroke-dashoffset] duration-700")}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    fill="none"
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className={cn("font-serif leading-none", size >= 48 ? "text-base" : "text-sm")}>{score}</span>
                <span className="text-[8px] uppercase tracking-[0.12em] text-muted-foreground mt-0.5">{label}</span>
            </div>
        </div>
    );
}
